import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import throttle from 'raf-throttle'
import styles from './styles.css'
import cn from 'classnames'

export default class SideNavigation extends PureComponent {
  static propTypes = {
    children: PropTypes.node
  }

  mounted = false

  state = {
    sticky: false
  }

  _update = () => {
    const sticky =
      window.innerWidth >= 768 && window.pageYOffset > this.nav.offsetTop

    if (sticky !== this.state.sticky) {
      this.setState({
        sticky
      })
    }
  }

  update = throttle(this._update)

  componentDidMount() {
    this.update()
    window.addEventListener('scroll', this.update)
    window.addEventListener('resize', this.update)

    window.setTimeout(() => {
      this.mounted = true
    }, 200)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.update)
    window.removeEventListener('resize', this.update)
  }

  render() {
    return (
      <nav
        ref={(el) => {
          this.nav = el
        }}
        className={styles.root}>
        <div
          className={cn(
            styles.sideNav,
            this.mounted && styles.mounted,
            this.state.sticky && styles.sticky
          )}>
          {this.props.children}
        </div>
      </nav>
    )
  }
}
